module.exports = __webpack_public_path__ + "static/media/github-logo.dec21930.svg";